import "../../../styles/components/Footer.scss";
import { FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  return (
    <>
      <footer className="site-footer">
        <div className="footer-top">
          {/* Column 1 */}
          <div className="footer-col">
            <h3>Dr. Ila Gupta</h3>
            <p>
              Chairperson & Chief Consultant IVF
              <br />
              Pristyn Care Ferticity Delhi
              <br />
              Co-founder & Director
              <br />
              Ferticity Delhi
            </p>
            <p>
              12, Navjeevan Vihar, Geetanjali Enclave,
              <br />
              Malviya Nagar, New Delhi, Delhi 110017
            </p>
          </div>

          {/* Column 2 */}
          <div className="footer-col">
            <h3>Our Services</h3>
            <ul>
              <li><a href="/infertility-treatment-in-delhi">Infertility Counselling</a></li>
              <li><a href="/artificial-insemination-iui">Artificial Insemination (IUI)</a></li>
              <li><a href="/ivf-treatment-in-delhi">IVF</a></li>
              <li><a href="/icsi">ICSI</a></li>
              <li><a href="/imsi">IMSI</a></li>
              <li><a href="/assisted-hatching">Assisted Hatching</a></li>
              <li><a href="/blastocyst-transfer">Blastocyst Transfer</a></li>
              <li><a href="/donor-egg-ivf">Donor Egg IVF</a></li>
            </ul>
          </div>

          {/* Column 3 */}
          <div className="footer-col">
            <h3>Our Services</h3>
            <ul>
              <li><a href="/donor-sperm-ivf">Donor Sperm IVF</a></li>
              <li><a href="/surrogacy">Surrogacy</a></li>
              <li><a href="/oocyte-and-embryo-freezing">Oocyte & Embryo Freezing</a></li>
              <li><a href="/testicular-aspiration-or-tesa">TESA</a></li>
              <li><a href="/microtesa">Micro TESA</a></li>
              <li><a href="/pre-genetic-screening-and-diagnosis">Genetic Screening</a></li>
              <li><a href="/fertility-enhancing-laparoscopy-and-hysteroscopy">Laparoscopy</a></li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="footer-disclaimer">
          <p>
            Disclaimer: The content on this website is for awareness only.
            Please consult a professional IVF specialist.
          </p>
        </div>

        {/* Bottom */}
        <div className="footer-bottom">
          <p>
            © 2026 Digimarq. All Rights Reserved. | Designed & Deployed by{" "}
            <a
              href="https://www.digimarqtechnology.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Digimarq technology Pvt
            </a>
          </p>
        </div>
      </footer>

      {/* ✅ WhatsApp Floating Button */}
      <a
        href="https://wa.me/9205020856?text=Hello%20Doctor,%20I%20want%20to%20book%20a%20consultation"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp className="whatsapp-icon" />
      </a>
    </>
  );
};

export default Footer;